module.exports = __webpack_public_path__ + "static/media/webpay.dc1edc2f.svg";